import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from "@material-ui/core/CircularProgress";
import BBLogo from "../assets/images/BreachBits_full_medres_transparent_fordarkbackground.png"
import {
     mfaLogin,
     mfaSendAltCode,

    showAuthLoader, userSignOut,
} from 'actions/Auth';
import {useForm} from "react-hook-form";
import {Col, Row} from "reactstrap";
import BBIconRedoArrow from "../assets/bbCustomIcons/BBIconRedoArrow";
import BBIconBackLeft from "../assets/bbCustomIcons/BBIconBackLeft";
import BBIconSMSText from "../assets/bbCustomIcons/BBIconSMSText";
import BBIconCallPhone from "../assets/bbCustomIcons/BBIconCallPhone";
import BBIconEmail from "../assets/bbCustomIcons/BBIconEmail";
import BBIconQRCodeOTP from "../assets/bbCustomIcons/BBIconQRCodeOTP";
import BBIconSMSTextQuestionMessage from "../assets/bbCustomIcons/BBIconSMSTextQuestionMessage";
import {bbShortenString} from "../util/bbHelpers";
import {Redirect} from "react-router-dom";

var pjson = require('../../package.json'); //to display version number

function ExpandMoreIcon() {
    return null;
}

const RegisterUser = (props) => {

  const dispatch = useDispatch();
  const {token, mfaSessionToken,refreshToken ,authUser, mfaLoginMeta, mfaAltCodeUserMessage, initURL} = useSelector(({auth}) => auth);
  const {loader} = useSelector(({auth}) => auth);

  // const {didJustRegisterUser} = useSelector(({auth}) => auth.appMisc);

  const mfaUserMessage = mfaLoginMeta && mfaLoginMeta.mfa_details ? mfaLoginMeta.mfa_details : null;
  const mfaPreference = mfaLoginMeta && mfaLoginMeta.mfa_preference ? mfaLoginMeta.mfa_preference : null;
  const mfaOptions = mfaLoginMeta && mfaLoginMeta.mfa_options ? mfaLoginMeta.mfa_options : null;

    // const [sessionToken, setSessionToken] = useState(mfaSessionToken ? mfaSessionToken : null);
    const [mfaAuthCode, setMfaAuthCode] = useState( null);
    const [mfaAltOptionIdSelected, setMfaAltOptionIdSelected] = useState(  null);
    const [openOptions, setOpenOptions] = useState( false);

  console.log("Bulding MFA verification page, here is mfaLoginMeta", mfaLoginMeta);



  const { register, handleSubmit, errors } = useForm();
  const onSubmit = data => {
    dispatch(showAuthLoader());
    dispatch(mfaLogin(mfaSessionToken, mfaAuthCode, mfaAltOptionIdSelected));
      if(mfaSessionToken) {
           if (initURL) {
              console.log("UseEffect on SIGNINMFAVERIFYICATION has initURL, going to", initURL)
              props.history.push(initURL);
          } else {
              console.log("UseEffect on SIGNINMFAVERIFYICATION NO initURL, going to /")

              props.history.push('/');
          }
      }
  }

    const logout = () => {
        console.log("Logging out from MFA page.");

        dispatch(userSignOut());
    }

    const sendBackupMethod = (mfaOptionId) => {
        console.log("Attempting to send an alternative code from verify login page for mfaOptionId", mfaOptionId);
        setMfaAltOptionIdSelected(mfaOptionId);

        dispatch(mfaSendAltCode(mfaSessionToken, mfaOptionId));
    }

    let primaryOption = null;

    const backupMfaOptions = mfaOptions && mfaPreference.hasOwnProperty("id")
        ? Object.keys(mfaOptions).reduce((object, key) => {
            if (key !== mfaPreference.id.toString()) {
                console.log("key is", key, "and preference id is",mfaPreference.id)
                object[key] = mfaOptions[key]
            } else {
                primaryOption = {
                    id: [key],
                    msg: mfaOptions[key]
                };
            }
            return object
        }, {})
        : {}

    const arrayOfBackupMfaOptions = backupMfaOptions
        ? Object.keys(backupMfaOptions).map((k) => {
            return {id: [k],
                msg: backupMfaOptions[k]}
        })
        : []

    const backupOption1 = arrayOfBackupMfaOptions.pop();
    const backupOption2 = arrayOfBackupMfaOptions.pop();
    const backupOption3 = arrayOfBackupMfaOptions.pop();

    const mfaOptionsIconLib = {
        0: <BBIconQRCodeOTP/>,
        1: <BBIconSMSText/>,
        2: <BBIconCallPhone/>,
        3: <BBIconEmail/>
    }

    console.log("backupOption1", backupOption1, "backupOption2", backupOption2, "mfaPreference", mfaPreference, "mfaOptions", mfaOptions, "backupMfaOptions", backupMfaOptions, "arrayOfBackupMfaOptions", arrayOfBackupMfaOptions, "token", token, "mfaSessionTokne", mfaSessionToken);

    // useEffect(()=>{
    //     console.log("Tokens updated---refreshToken is", bbShortenString(refreshToken, 40, true), "and current token is", bbShortenString(token,40,true), "mfaSessionToken is", bbShortenString(mfaSessionToken,40,true),);
    // }, [token, refreshToken, mfaSessionToken])


  useEffect(() => {
      if (token !== null && authUser && authUser.user.is_active) {
          console.log("From MFA verification page, user appears to be logged in, active, and ready to use App.")
          if(authUser
              && authUser.customers
              && Array.isArray(authUser.customers)
              && authUser.customers.length === 0){
              props.history.push(`/confirmNew`)
          }else if(initURL && initURL !== '/MFA' && initURL.toLowerCase() !== '/mfa'){
              console.log("UseEffect on SIGNINMFAVERIFYICATION has initURL, going to", initURL)
              props.history.push(initURL);
          } else{
              console.log("UseEffect on SIGNINMFAVERIFYICATION NO initURL, going to /")

              props.history.push('/');
          }
      }

  }, [props.history, dispatch, authUser, errors, mfaSessionToken]);

  return (
      <React.Fragment>
    <div
      className="app-login-container d-flex justify-content-center align-items-center animated fadeIn animation-duration-15">
      <div className="app-login-main-content">

          <div className="app-logo-content-wide d-flex align-items-center justify-content-center">
            <a className="logo-lg" href="https://www.breachbits.com" title="BreachBits">
              <img src={BBLogo} alt="BreachBits Logo" title="Learn more about BreachBits at breachbits.com"/>
            </a>
          </div>

        <div className="app-login-content-wide">
          <div className="app-login-header mb-4">
            <h1><IntlMessages id="appModule.mfaLogin"/></h1>
            <h4><IntlMessages id="appModule.mfaLogin.details"/></h4>

              {mfaAltCodeUserMessage || mfaAltOptionIdSelected
                  ? <div className={"border-2 p-2 bg-electric-blue text-white animated fadeIn animation-duration-7"}>
                      {mfaAltOptionIdSelected ? mfaOptionsIconLib[mfaAltOptionIdSelected] : null} {mfaAltCodeUserMessage}
                  </div>
                  : mfaUserMessage
                        ? <div className={"border-2 p-2 bg-green text-white animated fadeIn animation-duration-7"}>
                        {mfaPreference && mfaPreference.id != null ? mfaOptionsIconLib[mfaPreference.id] : null} {mfaUserMessage}
                        </div>
                        :<div className={"border-2 p-2 bg-lightest-gray animated fadeIn animation-duration-7"}>
                            <BBIconSMSTextQuestionMessage/> It appears that you were already sent a verification code, but the browser may have been reset. Select the Start Over button below if you don't have your code.
                        </div>
              }

          </div>

          <div className="app-confirm-form">
              <form id={"MFAVerificationSignInForm"} className="animated fadeIn animation-duration-7">

                  <div className={"row"}>
                      <div className={"col-12 text-center"}>
                          <TextField
                              label={<IntlMessages id="appModule.mfa.verify.authCode"/>}
                              // fullWidth
                              id="mfaAuthCode"
                              name="mfaAuthCode"
                              inputProps={{style: {fontSize: 30}}} // font size of input text
                              InputLabelProps={{style: {fontSize: 30}}} // font size of input label
                              // InputProps={{
                              //     startAdornment: (
                              //         <InputAdornment position="start">
                              //             <BBIconCyberKey/>
                              //         </InputAdornment>
                              //     ),
                              // }}
                              required
                              autoComplete={"off"}
                              autoFocus
                              error={errors.mfaAuthCode}
                              onChange={(event) => setMfaAuthCode(event.target.value)}
                              defaultValue={mfaAuthCode}
                              margin="normal"
                              className="mt-1 my-sm-3"
                              inputRef={register({
                                  required: <>Required. {mfaUserMessage}</> ,
                                  pattern: /^[0-9]{6}$/

                              })}
                              helperText={(errors.mfaAuthCode && <>A 6-digit code was sent to you. {mfaUserMessage}</>) || (errors.mfaAuthCode?.type === "pattern" && <>Invalid Format {mfaUserMessage}</>) || errors.mfaAuthCode?.message}
                          />


                              <Row>
                                  <Col>
                                      <Button onClick={handleSubmit(onSubmit)}
                                              disabled={errors.mfaAuthCode}
                                              variant="contained" color="primary"
                                              // endIcon={<BBIconCheckCircleYes />}
                                              className={"m-2"}
                                              type={"submit"}
                                      >
                                          <IntlMessages id="form.verifyAndLogin"/>
                                      </Button>
                                  </Col>
                              </Row>
                          <hr/>
                          <Row>
                              <Col>
                                  <Button
                                      variant={"contained"}
                                      onClick={logout}
                                      className={"m-2"}
                                      startIcon={<BBIconBackLeft/>}
                                  >
                                      Start Over
                                  </Button>
                              </Col>

                                  {primaryOption &&
                                      <Col>
                                          <Button
                                              variant={"contained"}
                                              onClick={() => sendBackupMethod(primaryOption.id)}
                                              className={"m-2"}
                                              startIcon={<BBIconRedoArrow/>}
                                          >
                                              Resend Code
                                          </Button>
                                          <br/> <em>{primaryOption.msg}</em>
                                      </Col>
                                  }


                          </Row>
                          {(backupOption1 || backupOption2) &&
                              <>
                                  <Button
                                      type={"text"}
                                      onClick={() => setOpenOptions(!openOptions)}
                                      className={"m-2"}
                                      startIcon={<BBIconSMSText/>}
                                      endIcon={<BBIconEmail/>}
                                  >Other Options To Get Your Code</Button>
                                  {openOptions &&
                                      <div className="animated fadeIn animation-duration-7">
                                          Is your primary verification method having trouble?
                                          <br/>
                                          Get a verification code now via one of these recovery options:
                                          {backupOption1 &&
                                              <Row>
                                                  <Col>
                                                      <Button
                                                      variant={"contained"}
                                                      onClick={() => sendBackupMethod(backupOption1.id)}
                                                      className={"m-2"}
                                                      startIcon={mfaOptionsIconLib[backupOption1.id]}
                                                      >
                                                        {backupOption1.msg}
                                                      </Button>
                                                  </Col>
                                              </Row>
                                          }
                                          {backupOption2 &&
                                              <Row>
                                                  <Col>
                                                      <Button
                                                      variant={"contained"}
                                                      onClick={() => sendBackupMethod(backupOption2.id)}
                                                      className={"m-2"}
                                                      startIcon={mfaOptionsIconLib[backupOption2.id]}
                                                      >
                                                        {backupOption2.msg}
                                                      </Button>
                                                  </Col>
                                              </Row>
                                          }
                                          {backupOption3 &&
                                              <Row>
                                                  <Col>
                                                      <Button
                                                          variant={"contained"}
                                                          onClick={() => sendBackupMethod(backupOption3.id)}
                                                          className={"m-2"}
                                                          startIcon={mfaOptionsIconLib[backupOption3.id]}
                                                      >
                                                          {backupOption3.msg}
                                                      </Button>
                                                  </Col>
                                              </Row>
                                          }
                                      </div>
                                  }
                              </>
                          }







                      </div>
                  </div>
              </form>

          </div>
          <div id={"version"}> v. {`${pjson.version}`}</div>
        </div>

      </div>


      {
        loader &&
        <div className="loader-view">
          <CircularProgress/>
        </div>
      }
      {/*{showMessage && NotificationManager.error(alertMessage, "Login Error", 10000)}*/}
      {/*<NotificationContainer/>*/}

    </div>
        <div className="break"> </div>
        {/*<div className={"app-login-subtitle"}>*/}
        {/*  <img src={require("assets/images/turn-the-tide-dark.png")} alt="breachbits" title="breachbits"/>*/}
        {/*</div>*/}
      </React.Fragment>
  );
};


export default RegisterUser;
